import { KYBER_API } from './api/endpoints'

export const HOST_PRODUCTION = 'https://kyber.pages.dev'
export const HOST = window?.location?.origin ?? HOST_PRODUCTION
export const NEXUS_BATTLEFRONT = 'https://www.nexusmods.com/starwarsbattlefront22017/'
export const MODS_SEARCH = `${NEXUS_BATTLEFRONT}/search/?gsearchtype=mods&gsearch=`
export const IMG_NEXUS_MOD = 'https://images.nexusmods.com/favicons/ReskinOrange/favicon-16x16.png'
export const IMG_URL_PREFIX = `${KYBER_API.hostName}/static/images/maps/`
export const IMG_URL_POSTFIX = '.jpg'
export const DISCORD_KYBER = 'https://discord.com/channels/305338604316655616/922585403180089344'
export const CLOUDFLARE_TRACE = 'https://www.cloudflare.com/cdn-cgi/trace'
export const GITHUB_EYEMVX = 'https://github.com/egorantonov'